export const createApplicationCache = (() => {
    const cache = new Map();
    return {
        getApplication: (id) => cache.get(id),
        addApplication: (id, application) => {
            cache.set(id, application);
        },
        hasApplication: (id) => cache.has(id),
    };
})();
export const APPLICATIONS_CACHED = createApplicationCache;
